import { Injectable } from '@angular/core';
import { Observable, of, catchError, delay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CachedDataService<T> {
  private cache: { [key: string]: Observable<T> } = {};

  get(key: string): Observable<T> | undefined {
    const cachedData = this.cache[key];
    if (cachedData) {
      return cachedData.pipe(
        catchError(() => {
          delete this.cache[key];
          return of(undefined);
        }),
      );
    }
    return undefined;
  }

  set(key: string, value: T, ttl: number = Number.MAX_SAFE_INTEGER): void {
    const observable = of(value).pipe(delay(ttl));
    this.cache[key] = observable;
  }

  clear(): void {
    this.cache = {};
  }
}
